import { environment } from './environments/environment';
//const apiUrlBase = environment.production ? 'http://96.89.127.59:9006/' : 'http://96.89.127.59:9006/'; // For pdx3
// const apiUrlBase = environment.production ? 'http://192.168.253.130:8000//' : 'http://192.168.253.130:8000/'; // For TEST server
// const apiUrlBase = environment.production ? 'http://localhost:61309/' : 'http://localhost:61309/'; // For local
//const apiUrlBase = environment.production ? 'http://pdx3.mimics.us:9018/' : 'http://pdx3.mimics.us:9018/'; // For pdx3
const apiUrlBase = environment.production ? 'https://onlineservice.marigotcreditunion.com:8000' : 'https://onlineservice.marigotcreditunion.com:8000'; // For MCCU TEST SERVER
const CONFIG = {
    environment: 'full',
    loginApiUrlBase: `${apiUrlBase}/api/MccuLogin`,
    profileApiUrlBase: `${apiUrlBase}/api/ModifyPassword`,
    sendemailApiUrlBase: `${apiUrlBase}/api/ForgotPassword`,
    usersApiUrlBase: `${apiUrlBase}/api/user`,
    positionsApiUrlBase: `${apiUrlBase}/api/PositionsGridView`,
    getAccountTransfer:`${apiUrlBase}/api/AccountTransfer`,
    getWithdrawData:`${apiUrlBase}/api/WithdrawData`,
    getAccountInfo:`${apiUrlBase}/api/GetAccountInfo`,
    documentsApiUrlBase: `${apiUrlBase}/api/Documents`,
    contactUsApiUrlBase: `${apiUrlBase}/api/contactus`,
    //getCurrencyData:`${apiUrlBase}/api/WithdrawData`,

    signupApiUrlBase: `${apiUrlBase}/api/signup`,
    getbanknamesApiUrlBase: `${apiUrlBase}/api/bankNames`,
};
export default CONFIG;